import Input from "./Input";
import Tags from "./Tags";
import DateTime from "./DateTime"
import Radio from "./Radio"
import CheckBox from "./CheckBox"
import TextArea from "./TextArea"
import HTML from "./HTML"
import Select from "./Select"
import Image from "./Image"
import File from "./File"
import Color from "./Color"
import Relation from "./Relation"
import Icons from "./Icons"
import GoogleMap from "./GoogleMap"
import Imagelocked from "./Imagelocked"
import Toggle from "./Toggle"
import Videoupload from "./Videoupload"
import Slider from "./Slider"
import Sliderlabels from "./Sliderlabels"
import Sliderhandles from "./Sliderhandles"
import Slidervariable from "./Slidervariable"
import Horario from "./Horario"
import Categorias from "./Categorias"
import Videos from "./Videos"
import Link from "./Link"
import Idcategorias from "./Idcategorias"
import Secciones from "./Secciones"
import Esponsors from "./Esponsors"
import Actualizaciones from "./Actualizaciones"
import Equipo from "./Equipo"
import Kaltura from "./Kaltura"
import Videofiltered from "./Videofiltered"
import Idplaylists from "./Idplaylists"


export {HTML,Input,Tags,Categorias,Idplaylists,Actualizaciones,Kaltura,Videofiltered,Equipo,Esponsors,Videos,Secciones,Idcategorias,Videoupload,Horario,DateTime,Radio,CheckBox,TextArea,Select,Image,File,Color,Relation,Icons,Toggle,GoogleMap,Slider,Slidervariable,Sliderlabels,Sliderhandles,Imagelocked,Link};



// WEBPACK FOOTER //
// ./src/components/fields/index.js